import type { Report } from '@/data/schemas';
import { resolveReportAt, toIsoDateFromDateTime } from '@/utils/inspectionScheduling';

export function normalizeReportScheduling(report: Report): Report {
  const plannedVisitAt = report.plannedVisitAt?.trim() || undefined;
  const reportAt = resolveReportAt(report);
  const derivedVisitDate = reportAt ? toIsoDateFromDateTime(reportAt) : report.meta.visitDate;
  const nextVisitDate = derivedVisitDate ?? report.meta.visitDate;

  if (
    report.reportAt === reportAt &&
    report.plannedVisitAt === plannedVisitAt &&
    report.meta.visitDate === nextVisitDate
  ) {
    return report;
  }

  return {
    ...report,
    reportAt,
    plannedVisitAt,
    meta: {
      ...report.meta,
      visitDate: nextVisitDate,
    },
  };
}
